// extracted by mini-css-extract-plugin
export default {"reactionToggleButton":"ReactionButton-module__reactionToggleButton__AXSSeqz","reactionToggleButtonReacted":"ReactionButton-module__reactionToggleButtonReacted__Db08lM5"};